import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import DossierActions from "../redux/DossierRedux";
import Layout from "../components/Layout";
import HeaderForm from "../components/HeaderForm/HeaderForm";
//import { Link } from "react-router-dom";
import Button from "../components/UI/Button/Button";
import Input from "../components/UI/Input/Input";
import InputEuroReadOnly from "../components/UI/Input/InputEuroReadOnly";
import FormError from "../components/UI/FormError/FormError";
import {
  updateObject,
  checkValidity,
  mergeDossierFormData,
  getEuro,
  isFormReadOnly,
  getFormErrors,
} from "../shared/utility";

import { votreBienForm2 } from "../shared/staticTexts";

import "./DossierVotreBienForm2.scss";

class DossierVotreBienForm2 extends React.Component {
  constructor(props) {
    super(props);

    if (props.dossier === null) {
      props.history.push("/dossier");
    }

    const dossier = props.dossier;
    let infosExercice = null;
    let currentBien = null;
    let bienId = null;
    let infoNM1 = null;
    if (dossier && props.location.state && props.location.state.currentBienId) {
      bienId = props.location.state.currentBienId;
      currentBien = dossier.biens.filter((bien) => bien.id === bienId)[0];
    }

    if (bienId !== null && currentBien.infosExercice) {
      infosExercice = currentBien.infosExercice;
    }

    if (bienId !== null && currentBien.infosExerciceNM1) {
      infoNM1 = currentBien.infosExerciceNM1;
    }

    this.state = {
      form: {
        totalEncaisse: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "totalEncaisse",
          },
          validation: {
            required: true,
            isEuro: true,
          },
          value:
            infosExercice !== null ? getEuro(infosExercice.totalEncaisse) : "",
          valid: false,
          touched: false,
          mn1: infoNM1 !== null ? getEuro(infoNM1.totalEncaisse) : "",
        },
        totalDepensesCourantes: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "totalDepensesCourantes",
          },
          validation: {
            required: true,
            isEuro: true,
          },
          value:
            infosExercice !== null
              ? getEuro(infosExercice.totalDepensesCourantes)
              : "",
          valid: false,
          touched: false,
          mn1: infoNM1 !== null ? getEuro(infoNM1.totalDepensesCourantes) : "",
        },
        totalTravaux: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "totalTravaux",
          },
          validation: {
            required: true,
            isEuro: true,
          },
          value:
            infosExercice !== null ? getEuro(infosExercice.totalTravaux) : "",
          valid: false,
          touched: false,
          mn1: infoNM1 !== null ? getEuro(infoNM1.totalTravaux) : "",
        },
        depensesEquipement: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "depensesEquipement",
          },
          validation: {
            required: true,
            isEuro: true,
          },
          value:
            infosExercice !== null
              ? getEuro(infosExercice.depensesEquipement)
              : "",
          valid: false,
          touched: false,
          mn1: infoNM1 !== null ? getEuro(infoNM1.depensesEquipement) : "",
        },
        impotsTaxeFonciere: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "impotsTaxeFonciere",
          },
          validation: {
            isEuro: true,
          },
          value:
            infosExercice !== null
              ? getEuro(infosExercice.impotsTaxeFonciere)
              : "",
          valid: false,
          touched: false,
          mn1: infoNM1 !== null ? getEuro(infoNM1.impotsTaxeFonciere) : "",
        },
        impotsCFE: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "impotsCFE",
          },
          validation: {
            isEuro: true,
          },
          value: infosExercice !== null ? getEuro(infosExercice.impotsCFE) : "",
          valid: false,
          touched: false,
          mn1: infoNM1 !== null ? getEuro(infoNM1.impotsCFE) : "",
        },
        chargesFinancieres: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "chargesFinancieres",
          },
          validation: {
            required: true,
            isEuro: true,
          },
          value:
            infosExercice !== null
              ? getEuro(infosExercice.chargesFinancieres)
              : "",
          valid: false,
          touched: false,
          mn1: infoNM1 !== null ? getEuro(infoNM1.chargesFinancieres) : "",
        },
        empruntCapitalRestantDu: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "empruntCapitalRestantDu",
          },
          validation: {
            required: true,
            isEuro: true,
          },
          value:
            infosExercice !== null
              ? getEuro(infosExercice.empruntCapitalRestantDu)
              : "",
          valid: false,
          touched: false,
          mn1: infoNM1 !== null ? getEuro(infoNM1.empruntCapitalRestantDu) : "",
        },
        commentaire: {
          elementType: "textarea",
          elementConfig: {
            type: "textarea",
            name: "commentaire",
            placeholder: votreBienForm2.form.commentaire.placeholder,
          },
          validation: {},
          value:
            infosExercice !== null && infosExercice.commentaire
              ? infosExercice.commentaire
              : "",
          valid: false,
          touched: false,
        },
      },
      bienId: bienId,
      currentBien: currentBien,
      formErrors: [],
      formIsValid: false,
      isUpdated: false,
      isSubmitted: false,
      dossier: dossier,
      isReadOnlyForm: isFormReadOnly(dossier),
    };
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (
      prevState.isSubmitted &&
      nextProps.dossier !== null &&
      prevState.dossier !== null
    ) {
      if (nextProps.dossier !== prevState.dossier) {
        nextProps.history.replace("/dossier/votre-bien");
      }
    }
    return nextProps;
  };

  submitHandler = (event) => {
    event.preventDefault();

    if (
      this.props.dossier &&
      this.props.dossier.status &&
      this.props.dossier.status !== "EnSaisie"
    ) {
      this.props.history.replace("/dossier/votre-bien");
      return false;
    }

    let formElements = {};
    for (let formElementIdentifier in this.state.form) {
      const formElementValue = this.state.form[formElementIdentifier].value;
      const updatedFormElement = updateObject(
        this.state.form[formElementIdentifier],
        {
          value: formElementValue,
          valid: checkValidity(
            formElementValue,
            this.state.form[formElementIdentifier].validation
          ),
          touched: true,
        }
      );

      formElements[formElementIdentifier] = updatedFormElement;
    }

    let formIsValid = true;
    let formData = {};
    for (let formElementIdentifier in formElements) {
      formIsValid = formElements[formElementIdentifier].valid && formIsValid;
      const value = formElements[formElementIdentifier].value;
      if (
        formElementIdentifier === "dateAcquisition" ||
        formElementIdentifier === "dateEntreeLMNP"
      ) {
        formData[formElementIdentifier] = moment(value).format("YYYY-MM-DD");
      } else if (
        formElements[formElementIdentifier].validation.isEuro === true
      ) {
        formData[formElementIdentifier] = value
          .toString()
          .replace(/\s+/g, "")
          .replace(",", ".");
      } else {
        formData[formElementIdentifier] = value;
      }
    }

    this.setState({
      form: formElements,
      formIsValid: formIsValid,
      formErrors: getFormErrors(formElements),
    });

    if (formIsValid) {
      if (this.state.isUpdated) {
        formData.id = this.state.bienId;
        const updatedDossier = mergeDossierFormData(
          "BienFormStep2",
          this.props.dossier,
          formData
        );

        this.setState({ isSubmitted: true });
        this.props.saveDossier(updatedDossier);
      } else {
        this.props.history.replace("/dossier/votre-bien");
      }
    }
  };

  inputChangedHandler = (event, inputIdentifier) => {
    const input = this.state.form[inputIdentifier];
    let value = event.target.value;
    if (input.validation.isEuro) {
      value = getEuro(value);
    }

    const updatedFormElement = updateObject(this.state.form[inputIdentifier], {
      value: value,
      valid: checkValidity(value, this.state.form[inputIdentifier].validation),
      touched: true,
    });

    const updatedForm = updateObject(this.state.form, {
      [inputIdentifier]: updatedFormElement,
    });

    let formIsValid = true;
    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({
      form: updatedForm,
      formIsValid: formIsValid,
      isUpdated: true,
    });
  };

  render() {
    let errorsMessages = "";
    if (this.props.error && this.props.errorMessage !== null) {
      errorsMessages = (
        <div className="alert alert-danger" role="alert">
          {this.props.errorMessage}
        </div>
      );
    }

    const formElementsArray = [];
    for (let key in this.state.form) {
      formElementsArray.push({
        id: key,
        config: this.state.form[key],
      });
    }

    let annee = "";
    if (this.props.dossier !== null) {
      annee = this.props.dossier.annee;
    }
    let bienAdresse = "";
    let bienCodePostal = "";
    let bienVille = "";
    if (this.state.currentBien !== null) {
      bienAdresse = this.state.currentBien.adresse;
      bienCodePostal = this.state.currentBien.codePostal;
      bienVille = this.state.currentBien.ville;
    }

    let form = (
      <form className="dossier-form py-5" onSubmit={this.submitHandler}>
        <fieldset className="bien-fs-border">
          <legend className="bien-fs-border">
            {votreBienForm2.form.fieldset1
              .replace("{annee}", annee)
              .replace("{adresse}", bienAdresse)}
          </legend>
          <div className="control-group">
            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label
                  htmlFor={formElementsArray[0].id}
                  className="col-form-label required"
                >
                  {votreBienForm2.form.totalEncaisse.label}
                </label>
              </div>
              <div className="col-sm-3">
                <Input
                  key={formElementsArray[0].id}
                  elementType={formElementsArray[0].config.elementType}
                  elementConfig={formElementsArray[0].config.elementConfig}
                  label={formElementsArray[0].config.label}
                  value={formElementsArray[0].config.value}
                  invalid={!formElementsArray[0].config.valid}
                  shouldValidate={formElementsArray[0].config.validation}
                  touched={formElementsArray[0].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[0].id)
                  }
                />
              </div>
              <div className="col-sm-3">
                <label className="readonly-label">Rappel {annee - 1}</label>
                <InputEuroReadOnly value={formElementsArray[0].mn1} />
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="bien-fs-border">
          <legend className="bien-fs-border">
            {votreBienForm2.form.fieldset2
              .replace("{annee}", annee)
              .replace("{adresse}", bienAdresse)}
          </legend>
          <div className="control-group">
            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label
                  htmlFor={formElementsArray[1].id}
                  className="col-form-label required"
                >
                  {votreBienForm2.form.totalDepensesCourantes.label1}
                  <br />
                  <small>
                    {votreBienForm2.form.totalDepensesCourantes.label2}
                  </small>
                </label>
              </div>
              <div className="col-sm-3">
                <Input
                  key={formElementsArray[1].id}
                  elementType={formElementsArray[1].config.elementType}
                  elementConfig={formElementsArray[1].config.elementConfig}
                  label={formElementsArray[1].config.label}
                  value={formElementsArray[1].config.value}
                  invalid={!formElementsArray[1].config.valid}
                  shouldValidate={formElementsArray[1].config.validation}
                  touched={formElementsArray[1].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[1].id)
                  }
                />
              </div>
              <div className="col-sm-3">
                <label className="readonly-label">Rappel {annee - 1}</label>
                <InputEuroReadOnly value={formElementsArray[1].mn1} />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label
                  htmlFor={formElementsArray[2].id}
                  className="col-form-label required"
                >
                  {votreBienForm2.form.totalTravaux.label1.replace(
                    "{annee}",
                    annee
                  )}
                  <br />
                  <small>{votreBienForm2.form.totalTravaux.label2}</small>
                </label>
              </div>
              <div className="col-sm-3">
                <Input
                  key={formElementsArray[2].id}
                  elementType={formElementsArray[2].config.elementType}
                  elementConfig={formElementsArray[2].config.elementConfig}
                  label={formElementsArray[2].config.label}
                  value={formElementsArray[2].config.value}
                  invalid={!formElementsArray[2].config.valid}
                  shouldValidate={formElementsArray[2].config.validation}
                  touched={formElementsArray[2].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[2].id)
                  }
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={formElementsArray[2].mn1} />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label
                  htmlFor={formElementsArray[3].id}
                  className="col-form-label required"
                >
                  {votreBienForm2.form.depensesEquipement.label.replace(
                    "{annee}",
                    annee
                  )}
                </label>
              </div>
              <div className="col-sm-3">
                <Input
                  key={formElementsArray[3].id}
                  elementType={formElementsArray[3].config.elementType}
                  elementConfig={formElementsArray[3].config.elementConfig}
                  label={formElementsArray[3].config.label}
                  value={formElementsArray[3].config.value}
                  invalid={!formElementsArray[3].config.valid}
                  shouldValidate={formElementsArray[3].config.validation}
                  touched={formElementsArray[3].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[3].id)
                  }
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={formElementsArray[3].mn1} />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label
                  htmlFor={formElementsArray[4].id}
                  className="col-form-label"
                >
                  {votreBienForm2.form.impotsTaxeFonciere.label1}
                  <br />
                  <small>{votreBienForm2.form.impotsTaxeFonciere.label2}</small>
                </label>
              </div>
              <div className="col-sm-3">
                <Input
                  key={formElementsArray[4].id}
                  elementType={formElementsArray[4].config.elementType}
                  elementConfig={formElementsArray[4].config.elementConfig}
                  label={formElementsArray[4].config.label}
                  value={formElementsArray[4].config.value}
                  invalid={!formElementsArray[4].config.valid}
                  shouldValidate={formElementsArray[4].config.validation}
                  touched={formElementsArray[4].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[4].id)
                  }
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={formElementsArray[4].mn1} />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label
                  htmlFor={formElementsArray[5].id}
                  className="col-form-label"
                >
                  {votreBienForm2.form.impotsCFE.label1}
                  <br />
                  <small>{votreBienForm2.form.impotsCFE.label2}</small>
                </label>
              </div>
              <div className="col-sm-3">
                <Input
                  key={formElementsArray[5].id}
                  elementType={formElementsArray[5].config.elementType}
                  elementConfig={formElementsArray[5].config.elementConfig}
                  label={formElementsArray[5].config.label}
                  value={formElementsArray[5].config.value}
                  invalid={!formElementsArray[5].config.valid}
                  shouldValidate={formElementsArray[5].config.validation}
                  touched={formElementsArray[5].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[5].id)
                  }
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={formElementsArray[5].mn1} />
              </div>
            </div>

            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label
                  htmlFor={formElementsArray[6].id}
                  className="col-form-label required"
                >
                  {votreBienForm2.form.chargesFinancieres.label1}
                  <br />
                  {votreBienForm2.form.chargesFinancieres.label2}
                  <br />
                  <small>{votreBienForm2.form.chargesFinancieres.label3}</small>
                </label>
              </div>
              <div className="col-sm-3">
                <Input
                  key={formElementsArray[6].id}
                  elementType={formElementsArray[6].config.elementType}
                  elementConfig={formElementsArray[6].config.elementConfig}
                  label={formElementsArray[6].config.label}
                  value={formElementsArray[6].config.value}
                  invalid={!formElementsArray[6].config.valid}
                  shouldValidate={formElementsArray[6].config.validation}
                  touched={formElementsArray[6].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[6].id)
                  }
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={formElementsArray[6].mn1} />
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="bien-fs-border">
          <legend className="bien-fs-border">
            {votreBienForm2.form.fieldset3.replace("{adresse}", bienAdresse)}
          </legend>
          <div className="control-group">
            <div className="form-row mb-3 pt-4">
              <div className="col-sm-6 text-right">
                <label
                  htmlFor={formElementsArray[7].id}
                  className="col-form-label required"
                >
                  {votreBienForm2.form.empruntCapitalRestantDu.label.replace(
                    "{annee}",
                    annee
                  )}
                </label>
              </div>
              <div className="col-sm-3">
                <Input
                  key={formElementsArray[7].id}
                  elementType={formElementsArray[7].config.elementType}
                  elementConfig={formElementsArray[7].config.elementConfig}
                  label={formElementsArray[7].config.label}
                  value={formElementsArray[7].config.value}
                  invalid={!formElementsArray[7].config.valid}
                  shouldValidate={formElementsArray[7].config.validation}
                  touched={formElementsArray[7].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[7].id)
                  }
                />
              </div>
              <div className="col-sm-3">
                <InputEuroReadOnly value={formElementsArray[7].mn1} />
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset className="bien-fs-border">
          <legend className="bien-fs-border">
            {votreBienForm2.form.fieldset4.replace("{annee}", annee)}
          </legend>
          <div className="control-group">
            <div className="form-row mb-3 pt-4">
              <div className="col-sm-12">
                <Input
                  key={formElementsArray[8].id}
                  elementType={formElementsArray[8].config.elementType}
                  elementConfig={formElementsArray[8].config.elementConfig}
                  label={formElementsArray[8].config.label}
                  value={formElementsArray[8].config.value}
                  invalid={!formElementsArray[8].config.valid}
                  shouldValidate={formElementsArray[8].config.validation}
                  touched={formElementsArray[8].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[8].id)
                  }
                />
              </div>
            </div>
          </div>
        </fieldset>

        <div className="form-row">
          <div className="mt-3 col-sm-12 text-right">
            {/*            <Link to="/dossier/votre-bien" className="btn btn-default mr-3">
              {votreBienForm2.buttonReturn}
            </Link> */}
            <Button classes="btn btn-success" btnType="Submit">
              {votreBienForm2.buttonSubmit}
            </Button>
          </div>
        </div>

        <FormError errors={this.state.formErrors} fullColumn="true" />
      </form>
    );

    return (
      <Layout>
        {errorsMessages}
        <HeaderForm step="3" isReadOnlyForm={this.state.isReadOnlyForm} />
        <h1 className="text-center">
          {votreBienForm2.title}
          {annee}
          <br />
          <small>
            {votreBienForm2.titleSmall
              .replace("{adresse}", bienAdresse)
              .replace("{codePostal}", bienCodePostal)
              .replace("{ville}", bienVille)}
          </small>
        </h1>
        {form}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dossier: state.dossiers.dossier,
    isFetching: state.dossiers.fetching,
    error: state.dossiers.error,
    errorMessage: state.dossiers.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveDossier: (dossier) => dispatch(DossierActions.saveDossier(dossier)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DossierVotreBienForm2);
